import { FunctionComponent, PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const Panel = styled(Box)({
  flex: 1,
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
});

export const SinglePanel: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <Panel>{children}</Panel>
);
